// extracted by mini-css-extract-plugin
export default {"ddflx":"dropdown_ddflx__w0-xe","vrot":"dropdown_vrot__iSOoP","frot":"dropdown_frot__YLnyH","ddmain":"dropdown_ddmain__pcqMc"};